export default __webpack_public_path__ + "resources/icons/d300-17f5.webp";